import { http } from "../helpers/easyindustriaapi/config";

export default class PessoaController {
  /**
   * Busca uma pessoa por CPF/CNPJ
   * @param {string} cpfCnpj - CPF ou CNPJ da pessoa
   * @param {number} empresaId - ID da empresa
   * @returns {Promise<Object>} - Dados da pessoa encontrada
   */
  static async buscarPorCpfCnpj(cpfCnpj, empresaId) {
    const response = await http.get(`pessoa/buscarPorCnpj?cnpj=${cpfCnpj}&empresa_id=${empresaId}`);
    return response.data;
  }

  /**
   * Cria uma nova pessoa
   * @param {Object} pessoaData - Dados da pessoa
   * @param {number} empresaId - ID da empresa
   * @returns {Promise<Object>} - Dados da pessoa criada
   */
  static async criar(pessoaData, empresaId) {
    const response = await http.post(`pessoa?empresa_id=${empresaId}`, pessoaData);
    return response.data;
  }

  /**
   * Cria uma nova pessoa (alias para criar)
   * @param {Object} pessoaData - Dados da pessoa
   * @returns {Promise<Object>} - Dados da pessoa criada
   */
  static async createPessoa(pessoaData) {
    const response = await http.post(`pessoa`, pessoaData);
    return response.data;
  }

  /**
   * Atualiza uma pessoa existente
   * @param {number} pessoaId - ID da pessoa
   * @param {Object} pessoaData - Dados da pessoa
   * @param {number} empresaId - ID da empresa
   * @returns {Promise<Object>} - Dados da pessoa atualizada
   */
  static async atualizar(pessoaId, pessoaData, empresaId) {
    const response = await http.put(`pessoa/${pessoaId}?empresa_id=${empresaId}`, pessoaData);
    return response.data;
  }

  /**
   * Lista todas as pessoas de uma empresa
   * @param {number} empresaId - ID da empresa
   * @returns {Promise<Array>} - Dados da pessoa
   */
  static async listar(empresaId) {
    const response = await http.get(`pessoa?empresa_id=${empresaId}`);
    return response.data;
  }

  /**
   * Lista todas as pessoas (sem filtro de empresa)
   * @returns {Promise<Array>} - Lista de pessoas
   */
  static async getPessoas() {
    const response = await http.get(`pessoa`);
    return response.data;
  }

  /**
   * Busca uma pessoa por ID
   * @param {number} pessoaId - ID da pessoa
   * @param {number} empresaId - ID da empresa
   * @returns {Promise<Object>} - Dados da pessoa
   */
  static async buscarPorId(pessoaId, empresaId) {
    const response = await http.get(`pessoa/${pessoaId}?empresa_id=${empresaId}`);
    return response.data;
  }

  /**
   * Exclui uma pessoa
   * @param {number} pessoaId - ID da pessoa
   * @param {number} empresaId - ID da empresa
   * @returns {Promise<Object>} - Resultado da exclusão
   */
  static async excluir(pessoaId, empresaId) {
    const response = await http.delete(`pessoa/${pessoaId}?empresa_id=${empresaId}`);
    return response.data;
  }
}
